import React from 'react';
import { CLIMATEMPO_GET } from '../../Api';
import { useDispatch, useSelector } from 'react-redux';
import { loadClima } from '../../store/climatempo';
import ClimaTempoIcon from './ClimaTempoIcon.js';

const ClimaTempo = () => {

  const climatempox = useSelector((state) => state.climatempo);
  const dispatch = useDispatch();
  let code = null; 
  let desc = null;

   React.useEffect(() => {
    dispatch(loadClima());
  }, [dispatch]);

  React.useEffect(() => {
    //setimage();
    code = climatempox?.data?.weather?.[0]?.icon;      // ex: '10d'
    desc = climatempox?.data?.weather?.[0]?.description || '';
  }, [climatempox]);

  function setimage() {
    let img = document.getElementById('climatempo'); 
    try{
      //let imgt = `https://openweathermap.org/img/w/${climatempox.data.weather[0].icon}.png`;
      let imgt = `icons/${climatempox.data.weather[0].icon}.png`;
      img.src = imgt;
      img.alt = climatempox.data.weather[0].description;
      img.title = climatempox.data.weather[0].description;
    } catch(e) {
      console.log(e);
    }
  }

  function atualizarTempo()
  {
    fetch('https://api.openweathermap.org/data/2.5/weather?lat=-30.0277&lon=-51.2287&appid=4e010b936c2cab40b3ea5e5c31855342', {
      method: "GET",
      headers: {"Content-type": "application/json; charset=UTF-8"}
    })
    .then(response => response.json()) 
    .then(json => setimage(json))
    .catch(err => console.log(err));
  }

  return (
      //<div>
      //<span><img id="climatempo" style={{ maxHeight: '2.1rem', backgroundColor: '#fff', borderRadius: '50%'}} src=''/></span>
      <ClimaTempoIcon code={code} alt={desc}/>
      //</div>
    );
};

export default ClimaTempo;
